import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUserIsAdmin } from '@mm/state/selectors/userSelector';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { CSVDropParser as LibCsvDropParse, IParsedData } from '@mm/components';

export type ParsedData = IParsedData;

export const CSVDropParser = props => {
  const isSysOrCSAdmin = useSelector(selectCurrentUserIsAdmin);
  const facebookPage = useSelector(activeFacebookPageSelector);
  const maxSize =
    (isSysOrCSAdmin ? 10 : facebookPage?.free ? 2 : 5) * 1024 * 1024;

  return <LibCsvDropParse {...props} maxSize={maxSize} />;
};
